import _, { isEmpty } from 'lodash';
import React from 'react';

import {
  queryGetSubscription,
  queryMyProfile,
  queryDeleteCreditCards,
  queryGetFacilitySettings,
} from '../../../Queries';

import { getFacility } from '../../../Utils/facility';

import ProcessingIndicator from '../../Common/ProcessingIndicator';
import ActionButton from '../../Common/ActionButton';
import NoticeBlock from '../../Common/NoticeBlock';

import Field from '../../Fields/Field';

import '../Page.scss';
import './SubscriptionPaymentOptions.scss';
import GPICreditCardForm from './GPI/GPICreditCardForm';
import GPIBankAccountForm from './GPI/GPIBankAccountForm';
import { queryDeleteBankAccounts } from '../../../Queries/Subscription';

const profileQueryFields = ['gpi_cards', 'gpi_bank_accounts'];

const subscriptionQueryFields = [{ payor: ['cognito_sub'] }];

class SubscriptionPaymentOptions extends React.Component {
  state = {
    pageInitializationComplete: false,
    pageInitializationErrors: [],
    cognitoSub: null,
    facilityId: null,
    facility: null,
    creditCardInputs: {
      cardNumber: '',
      expiryDate: '',
      cvc: '',
      address: '',
      zipCode: '',
    },
    bankDetails: [],
    creditCardDetails: [],
    saveInProgress: false,
    queryInProgress: false,
    success: false,
    deleteCard: false,
    showBankDetails: true,
  };

  constructor(props) {
    super(props);

    const urlSearchParams = new URLSearchParams(window.location.search);

    const facilityId = urlSearchParams.get('facility');
    this.state.facilityId = facilityId;
  }

  async componentDidMount() {
    const script = document.createElement('script');
    script.src =
      'https://js.paygateway.com/secure_payment/v1/globalpayments.js';
    script.async = true;

    document.body.appendChild(script);
    let settingsResponse = null;
    const facilitySettingsFields = ['use_ach'];

    try {
      let facility = null;
      if (this.state.facilityId) {
        facility = await getFacility(this.state.facilityId);
        settingsResponse = await queryGetFacilitySettings(
          {
            facility_id: this.state.facilityId,
          },
          facilitySettingsFields
        );
      }
      await this.fetchPayor();
      this.setState({
        pageInitializationComplete: true,
        facility,
        showBankDetails: settingsResponse.data.getFacilitySettings.use_ach,
      });
    } catch (errors) {
      this.setState({
        pageInitializationComplete: true,
        pageInitializationErrors: errors.map(({ message }) => message),
        showBankDetails: true,
      });
    }
  }

  async fetchPayor() {
    const response = await queryGetSubscription(
      {
        subscription_id: this.props.subscriptionId,
      },
      subscriptionQueryFields
    );
    if (response.errors) {
      throw response.errors.map((error) => error.message);
    }
    const cognitoSub =
      response.data.getSubscription.payor.cognito_sub;
    this.setState({ cognitoSub }, async () => {
      await this.getMyProfile(true);
    });
  }

  async getMyProfile(inProgress) {
    this.setState({
      queryInProgress: inProgress,
    });
    if (this.state.cognitoSub) {
      const variables = {
        cognitoSub: this.state.cognitoSub,
      };
      const response = await queryMyProfile(variables, profileQueryFields);
      const bankDetails = response.data.myProfile.gpi_bank_accounts;
      const creditCardDetails = response.data.myProfile.gpi_cards.map(
        (card) => {
          return { ...card, selected: false };
        }
      );
      this.setState({ bankDetails, creditCardDetails });
    }
    this.setState({
      queryInProgress: false,
    });
  }

  handleDeleteCreditCards = async () => {
    try {
      const creditCards = this.state.creditCardDetails.filter(
        (card) => card.selected
      );
      const variables = {
        cognitoSub: this.state.cognitoSub,
        cardToken: creditCards.map((card) => card.token),
      };
      const response = await queryDeleteCreditCards(variables);
      if (response.errors) throw response.errors;
      await this.getMyProfile(false);
      this.setState({ deleteCard: true });
      setTimeout(() => {
        this.setState({ deleteCard: false });
      }, 3000);
    } catch (error) {
      alert(error);
    }
  };

  handleDeleteBankAccounts = async () => {
    try {
      const bankAccounts = this.state.bankDetails.filter(
        (account) => account.selected
      );
      const variables = {
        cognitoSub: this.state.cognitoSub,
        accountTokens: bankAccounts.map((card) => card.token),
      };
      const response = await queryDeleteBankAccounts(variables);
      if (response.errors) throw response.errors;
      await this.getMyProfile(false);
      this.setState({ accountsDeleted: true });
      setTimeout(() => {
        this.setState({ accountsDeleted: false });
      }, 3000);
    } catch (error) {
      alert(error);
    }
  };

  handleSelectCards = (index, selected) => {
    const creditCardDetails = _.cloneDeep(this.state.creditCardDetails);
    creditCardDetails[index].selected = selected;

    this.setState({ creditCardDetails });
  };

  handleSelectBankAccounts = (index, selected) => {
    const bankDetails = _.cloneDeep(this.state.bankDetails);
    bankDetails[index].selected = selected;

    this.setState({ bankDetails });
  };

  renderAddNewCreditCardForm(isViewOnly) {
    return (
      <div>
        <GPICreditCardForm
          cognitoSub={this.state.cognitoSub}
          getCreditCards={() => this.getMyProfile(false)}
          isViewOnly={isViewOnly}
          saveCardInfo={true}
        />
      </div>
    );
  }

  renderCreditCards() {
    const { creditCardDetails, deleteCard } = this.state;

    const creditCards = creditCardDetails.filter((card) => card.selected);
    const isViewOnly = this.props.paymentOptions === 'DISPLAY_AND_VIEW_ONLY';

    return (
      <div>
        <Field
          label={'Manage Credit Cards'}
          id='parkchirp--subscription-list-filter--account-id'
          containerClasses={[
            'parkchirp--subscription-payment-options-panel-fields',
          ]}
          layout='stacked'
        >
          {creditCardDetails.map((card, index) => (
            <span className='parkchirp--input-checkbox-option'>
              <input
                type='checkbox'
                value={card.token}
                checked={card.selected}
                onChange={(e) =>
                  this.handleSelectCards(index, e.target.checked)
                }
                disabled={isViewOnly}
              />
              <label>
                {card.type} ending in {card.last4}, {card.exp_month}/
                {card.exp_year}
              </label>
            </span>
          ))}
          <div className='parkchirp--payment-action-button'>
            <ActionButton
              id='parkchirp--invoice-refund-action-button'
              label='Delete Selected Cards'
              disabled={isEmpty(creditCards) || isViewOnly}
              onClick={this.handleDeleteCreditCards}
            />
            {deleteCard && (
              <div className='parkchirp--payment-success-text'>
                <NoticeBlock
                  type='message'
                  containerClasses={['parkchirp--sidebar-block']}
                >
                  <p>Successfully deleted</p>
                </NoticeBlock>
              </div>
            )}
          </div>
          <h3 className='parkchirp--payment-add-card'>Add Credit Card</h3>
          {this.renderAddNewCreditCardForm(isViewOnly)}
        </Field>
      </div>
    );
  }
  renderBankAccounts() {
    const { bankDetails, accountsDeleted } = this.state;

    const bankAccounts = bankDetails.filter((account) => account.selected);
    const isViewOnly = this.props.paymentOptions === 'DISPLAY_AND_VIEW_ONLY';
    return (
      <div>
        <Field
          label={'Manage Bank Accounts'}
          id='parkchirp--subscription-list-filter--account-id'
          containerClasses={[
            'parkchirp--subscription-recurring-payments-panel-fields',
          ]}
          layout='stacked'
        >
          {bankDetails.map((account, index) => (
            <span className='parkchirp--input-checkbox-option'>
              <input
                type='checkbox'
                value={account.token}
                checked={account.selected}
                onChange={(e) => this.handleSelectBankAccounts(index, e.target.checked)}
                disabled={isViewOnly}
              />
              <label>
                {account.accountType} account ending in {account.last4}
              </label>
            </span>
          ))}
          <div className='parkchirp--payment-action-button'>
            <ActionButton
              id='parkchirp--invoice-refund-action-button'
              label='Delete Selected Accounts'
              disabled={isEmpty(bankAccounts) || isViewOnly}
              onClick={this.handleDeleteBankAccounts}
            />
            {accountsDeleted && (
              <div className='parkchirp--payment-success-text'>
                <NoticeBlock
                  type='message'
                  containerClasses={['parkchirp--sidebar-block']}
                >
                  <p>Successfully deleted</p>
                </NoticeBlock>
              </div>
            )}
          </div>
          <h3>Manage Bank Account</h3>
          <GPIBankAccountForm
            cognitoSub={this.state.cognitoSub}
            getBankAccounts={() => this.getMyProfile(false)}
          />
        </Field>
      </div>
    );
  }

  render() {
    const { pageInitializationComplete, queryInProgress, showBankDetails } = this.state;

    if (!pageInitializationComplete || queryInProgress) {
      return (
        <div className='parkchirp--page--user-message-container'>
          <ProcessingIndicator userMessage='Please Wait...' />
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className='parkchirp--page parkchirp--page--subscription-payment-options-panel'>
          {this.renderCreditCards()}
          {showBankDetails && this.renderBankAccounts()}
        </div>
      </React.Fragment>
    );
  }
}
export default SubscriptionPaymentOptions;
